import { cva } from 'class-variance-authority';

const navigationBarItemContainerStyles = cva("mci-flex mci-items-center");
const navigationBarItemStyles = cva("mci-flex mci-w-full mci-gap-s mci-items-center mci-outline-brand -mci-outline-offset-1 mci-transition-colors mci-duration-fast mci-rounded-3 mci-text-left mci-p-xs", {
    defaultVariants: {
        bold: true,
        isActive: false,
        withHoverEffects: true,
    },
    variants: {
        bold: {
            true: "mci-font-semibold",
            false: "",
        },
        isActive: {
            true: "mci-bg-gray-200",
            false: "",
        },
        withHoverEffects: {
            true: "hover:mci-bg-gray-200",
            false: "",
        },
    },
});
const navigationBarIconContainer = cva("mci-flex mci-w-[1.25rem] mci-h-[1.25rem] mci-items-center mci-justify-center");
const navigationBarIconInnerContainer = cva("mci-max-h-m mci-w-full mci-flex mci-size-full");
const navItemTooltipContainer = cva("mci-rounded mci-bg-white mci-px-s mci-py-xs mci-text-body-small mci-font-semibold mci-shadow-2");
const navItemLabelContainer = cva("mci-flex-1 mci-text-body-small", {
    variants: {
        screenReaderOnly: {
            true: "mci-sr-only",
            false: "",
        },
    },
});
const popoverItemList = cva("mci-flex mci-flex-col mci-gap-xs mci-py-xs");
const popoverContainer = cva("mci-my-xs mci-rounded mci-bg-white mci-text-body-small mci-font-semibold mci-shadow-2", {
    variants: {
        isExpanded: {
            true: "mci-w-[152px]",
            false: "mci-w-[173px]",
        },
    },
});

export { navItemLabelContainer, navItemTooltipContainer, navigationBarIconContainer, navigationBarIconInnerContainer, navigationBarItemContainerStyles, navigationBarItemStyles, popoverContainer, popoverItemList };
